'use strict';

// Library Includes
var moment = require('moment');

// Helper Includes
var helpers = {
    validation: require('../utilities/helpers/validation')
};

// Constant Includes
var CONSTANTS = {
    DATEPICKER: require('../constants/datepicker')
};

// Constants
var ATTRIBUTES = CONSTANTS.DATEPICKER.ATTRIBUTES;
var CONFIG = CONSTANTS.DATEPICKER.CONFIG;

/**
 * Initialize a date picker model based on the bootstrap date picker library.
 * Access for more information: https://bootstrap-datepicker.readthedocs.io/en/latest/index.html
 * @constructor
 * @param {JQuery<HTMLElement> | string} $element - JQuery HTML element to attach the date picker functionality
 */
function DatepickerModel($element) {
    /** ********************************************************
     * Initialize and document each and every object property.
     *                        START
     ******************************************************** */

    /**
     * Date picker div element. It is only not null if date picker is attached to a div HTML element.
     * @type {JQuery<HTMLElement>}
     */
    this.$div = null;

    /**
     * Element to attach the date picker.
     * @type {JQuery<HTMLElement>}
     */
    this.$element = null;

    /**
     * Date picker input element.
     * @type {JQuery<HTMLElement>}
     */
    this.$input = null;

    /**
     * Date picker end/max date. No end/max date is set if none is provided in a data attribute.
     * @type {string}
     */
    this.endDate = null;

    /**
     * Date picker date format. Use a fallback format if none is provided in a data attribute.
     * @type {string}
     */
    this.format = null;

    /**
     * Date picker identifier. May be declared or auto-generated.
     * @type {string}
     */
    this.id = null;

    /**
     * Determines if the date picker is attached to a div.
     * @type {boolean}
     */
    this.isDestroyed = false;

    /**
     * Determines if the date picker is attached to a div.
     * @type {boolean}
     */
    this.isDiv = false;

    /**
     * Determines if the date picker id is auto-generated.
     * @type {boolean}
     */
    this.isGeneratedId = false;

    /**
     * Date picker start/min date. No start/min date is set if none is provided in a data attribute.
     * @type {string}
     */
    this.startDate = null;

    /** ********************************************************
     * Initialize and document each and every object property.
     *                        END
     ******************************************************** */

    // Variables
    var THIS = this;
    var $input;
    var id;
    var formattedDate;

    // 1. Object base properties
    this.$element = $($element);

    if (this.$element.length === 0) {
        return;
    }

    this.endDate = this.$element.attr(ATTRIBUTES.DATA.END_DATE);
    this.format = this.$element.attr(ATTRIBUTES.DATA.FORMAT);
    this.startDate = this.$element.attr(ATTRIBUTES.DATA.START_DATE);

    // 2. Set date picker id
    id = this.$element.attr(ATTRIBUTES.DATA.ID);

    if (!helpers.validation.isValidString(id)) {
        id = crypto.getRandomValues(new Uint32Array(1)).toString();
        this.isGeneratedId = true;
        this.$element.attr(ATTRIBUTES.DATA.ID, id);
    }

    this.id = id;

    // 3. Create a new datepicker instance
    this.$input = this.$element.datepicker({
        language: $('html').attr('lang'),
        format: helpers.validation.isValidString(this.format) ? this.format : CONFIG.FORMAT,
        startDate: helpers.validation.isValidString(this.startDate) ? this.startDate : undefined,
        endDate: helpers.validation.isValidString(this.endDate) ? this.endDate : undefined,
        maxViewMode: CONFIG.MAX_VIEW_MODE.DAYS
    });

    // 4. If the datepicker is a div, create an input that will store the selected value
    if (this.$element[0].tagName.toLowerCase() === 'div') {
        $input = $(`input[${ATTRIBUTES.DATA.ID}=${this.id}]`);

        if ($input.length === 0) {
            $input = $(`<input type="hidden" data-date-id=${this.id} />`);

            $input.insertAfter(this.$element);
        }

        this.isDiv = true;
        this.$div = $input;
        this.$input = $input;

        this.$element.on('changeDate', function () {
            formattedDate = moment(new Date(THIS.$element.datepicker('getUTCDates'))).format(moment.defaultFormatUtc);
            THIS.$input.val(formattedDate);
        });
    }

    // 5. Set date picker as loaded
    this.$element.attr(ATTRIBUTES.DATA.IS_LOADED, 'true');
}

/**
 * Destroy a bootstrap date picker instance.
 */
DatepickerModel.prototype.destroy = function () {
    this.$element.datepicker('destroy');
    this.isDestroyed = true;
};

module.exports = DatepickerModel;
